module.exports = __webpack_public_path__ + "img/tick.342fe75c.jpg";